import React, { useState } from "react";
import { Spinner } from "@chakra-ui/react";

interface LdapLoginButtonProps {
	usernameRef?: React.RefObject<HTMLInputElement> | ((instance: HTMLInputElement | null) => void);
	passwordRef?: React.RefObject<HTMLInputElement> | ((instance: HTMLInputElement | null) => void);
	loginInProgress?: boolean;
	onPasswordChange?: () => void;
	onUsernameChange?: () => void;
	handleSubmit: (username: string, password: string) => void;
}

const LdapLoginButton: React.FC<LdapLoginButtonProps> = ({
	usernameRef,
	passwordRef,
	loginInProgress = false,
	onPasswordChange,
	onUsernameChange,
	handleSubmit,
}) => {
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");

	const handleChangeUsername = (event: React.ChangeEvent<HTMLInputElement>) => {
		setUsername(event.target.value);
		onUsernameChange?.();
	};

	const handleChangePassword = (event: React.ChangeEvent<HTMLInputElement>) => {
		setPassword(event.target.value);
		onPasswordChange?.();
	};

	const handleFormSubmit = (event: React.FormEvent) => {
		event.preventDefault();
		if (!loginInProgress) {
			handleSubmit(username.toLowerCase(), password);
		}
	};

	const handleEnterPressed = (event: React.KeyboardEvent) => {
		if (event.key === "Enter" && !loginInProgress) {
			event.preventDefault();
			event.stopPropagation();
			handleFormSubmit(event);
		}
	};

	return (
		<div onKeyUp={handleEnterPressed} data-testid="ldap-login-container">
			<label className="form-label" data-testid="username-label">
				Username
			</label>
			<input
				ref={usernameRef}
				className="form-input"
				placeholder="Enter your username"
				autoComplete="on"
				value={username}
				onChange={handleChangeUsername}
				id="username"
				name="username"
				data-testid="username-input"
			/>
			<label className="form-label" data-testid="password-label">
				Password
			</label>
			<input
				ref={passwordRef}
				className="form-input"
				placeholder="Enter your password"
				value={password}
				onChange={handleChangePassword}
				type="password"
				id="password"
				name="password"
				data-testid="password-input"
			/>
			{loginInProgress ? (
				<button className="large login-ldap-button" disabled>
					<div>
						<Spinner color="white" width={"12px"} height={"12px"} data-testid="spinner" />
					</div>
				</button>
			) : (
				<button className="large login-ldap-button" onClick={handleFormSubmit} data-testid="sign-in-button">
					Sign In
				</button>
			)}
		</div>
	);
};

export default LdapLoginButton;
